import { type Environment } from 'react-relay';

import { initialMentionAgents } from '../../services/mention-agents/initial-mention-agents.ts';
import { searchMentionAgents } from '../../services/mention-agents/search-mention-agents.ts';
import type { MentionAgent, MentionAgentSource } from '../../services/mention-agents/types.ts';

export type CreateMentionAgentSourceParams = {
	environment: Environment;
	cloudId: string | undefined;
	product: string;
	workspaceId?: string;
};

const inertSource: MentionAgentSource = {
	getAllAgents: async () => [],
	searchByName: async () => [],
	canFilterClientSide: () => false,
};

export const createMentionAgentSource = (
	params: CreateMentionAgentSourceParams,
): MentionAgentSource => {
	const { environment, cloudId, product, workspaceId } = params;
	if (!cloudId) {
		return inertSource;
	}

	let lastCanFilterClientSide = false;

	return {
		getAllAgents: async (signal) => {
			try {
				const result = await initialMentionAgents({
					environment,
					cloudId,
					product,
					workspaceId,
					signal,
				});
				lastCanFilterClientSide = result.canFilterClientSide;
				return result.mergedAgents;
			} catch {
				return [];
			}
		},
		searchByName: (name, signal) =>
			searchMentionAgents({
				environment,
				cloudId,
				product,
				workspaceId,
				name,
				signal,
			}).catch(() => [] as readonly MentionAgent[]),
		canFilterClientSide: () => lastCanFilterClientSide,
	};
};
